import React from "react";
import Loader from 'react-loader-spinner'
// import FilterViewer from "../FilterViewer";
import Modal from "../components/Modal";
import { translate } from "../utils/useful";
import FilterViewer from "../components/FilterViewer";


class FilterModal extends React.Component {
  state = {
    // isLoadingRemove: false,
    id: null,
    index: null
  }

  showModal = (id, index) => {
    this.setState({ id, index })
    this.modal.showModal()
  }

  changeFilter = (key, value) => {
    // console.log(value)
    let filters = this.state.filters
    if (!filters) filters = {}
    if (value == false || value == null) {
      delete filters[key]
    } else {
      value = value
      filters[key] = { key, value }
    }

    this.setState({ filters }, () => {
      // console.log(filters)
    })
  }

componentDidMount(){
  // console.log('filterModal1')
}
componentDidUpdate(){
  // console.log('filterModal2')
}


  render() {
    return (
      <Modal maxWidth={400} ref={el => this.modal = el}>


        <div className="text-center" style={{ backgroundColor: '#fff', borderRadius: 8 }}>
          <div className="w-100" style={{ zIndex: 1, padding: '12px 22px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '0px #eee solid', backgroundColor: '#f2f6f8ee', background: 'linear-gradient(to right,#d7e2f7dd,#dad6e4dd)', backdropFilter: 'blur(10px) saturate(180%)', WebkitBackdropFilter: 'blur(10px) saturate(180%)', borderRadius: '8px 8px 0px 0px' }}>

            <p className="text-bold mb-0 text-normal ">{translate('Advanced Search')}</p>

            <div className="cursor-pointer" onClick={() => this.hideModal()} style={{ width: 30, height: 30, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <img style={{ width: 14, height: 14 }} src="/assets/icons/close.svg" alt="" />
            </div>

          </div>
          <div className="pt-2 px-3 pb-2">
            <FilterViewer changeFilter={this.changeFilter} headers={this.props.headers} data={this.state.filters} errors={this.state.errors} inputClass={''} />


            <div className="mt-2 blur-back pb-2" style={{ position: 'sticky', bottom: 0, backgroundColor: '#ffffffbb' }}>
              {!this.props.isLoading && (
                <div className="flexcc mt-2 w-100">

                  <button className="w-100 m-1 p-2 px-4 white text-bold text-uppercase" onClick={() => this.modal.hideModal()} style={{ borderRadius: 6, backgroundColor: '#789', }}>
                    <p className="text-normal text-uppercase">{translate("cancel")}</p>
                  </button>

                  <button className="w-100 m-1 p-2 px-4 white text-bold text-uppercase" onClick={() => { this.props.doFilter() }} style={{ backgroundColor: '#677dc4', borderRadius: 6, }}>
                    <p className="text-normal text-uppercase">{translate('useful.submit')}</p>
                  </button>
                </div>
              )}
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                {this.props.isLoading && (
                  <Loader
                    type="Puff"
                    color="rgba(0,122,255,1)"
                    height="40"
                    width="40"
                  />)}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}



export default FilterModal;
